import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  headersMedsus,
  MedsusTableRow,
  valoresExibidosOffCanvasMedsus as valoresExibidos,
} from './auxliarProdutoMedsus';
import { DiretrizDetailBox } from './components/DiretrizDetailBox';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { IMedsusDiretrizRegistro } from '../../../../modules/types/MedsusNew';
import { getAllMedsusDiretriz } from '../../../../services/medsus/medsusDiretrizService';
import SubAbas from '../subabas';

interface MedsusIndexProps {
  subAbas?: { label: string; rota: string }[];
}

const MedsusIndex: React.FC<MedsusIndexProps> = ({ subAbas = SubAbas }) => {
  //PERMISSOES
  const navigate = useNavigate();
  const location = useLocation();

  //DADOS USUARIO
  const { cudProdutoDaf } = useContext(UserContext);

  const [data, setData] = useState<IMedsusDiretrizRegistro[]>([]);
  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllMedsusDiretriz();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tableData: MedsusTableRow[] = data?.map(
    (item: IMedsusDiretrizRegistro) => {
      const medicamentos = Array.isArray(item.diretrizesVmp)
        ? item.diretrizesVmp
            .map((dvmp) => `${dvmp.vmp.obm} ${dvmp.vmp.nome}`)
            .join('; ')
        : 'Nenhum medicamento vinculado';

      return {
        id: item.id,
        nome: item.nome ?? 'Não informado',
        medicamento: medicamentos,
      };
    },
  );

  const handleClickInserir = () => {
    // handleShowModalInserir();
    navigate('dadosgerais');
  };

  const handleTableRowClick = (row: MedsusTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  const handleOpenDetails = (row: MedsusTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const offcanvasOpenRoute = useMemo(() => {
    if (typeof window === 'undefined') return undefined;
    if (!selectedDetailsRowId) return undefined;
    const fichaPath = `${selectedDetailsRowId}/dadosgerais`;
    return `${window.location.origin}/#${location.pathname}/${fichaPath}`;
  }, [selectedDetailsRowId, location.pathname]);

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersMedsus}
          data={tableData}
          displayValues={valoresExibidos}
          offcanvasTitle="Diretriz Clínica"
          widthOffcanvas="60%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={20}
          showPagination
          showOpenButton
          filterable
        >
          {(row) => (
            <DiretrizDetailBox
              medsusDiretrizRegistro={data.find(
                (produto) => produto.id === row?.id,
              )}
              isCollapsed={false}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // downloadDisabled={!btDisable}
          inserir
          inserirDisabled={!cudProdutoDaf}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MedsusIndex;
